import React from "react";
import { Check } from "lucide-react";
import { FOOTER, SITE } from "../data/nav";

export const SiteFooter = () => {
  return (
    <footer className="bg-asphalt text-white" data-testid="site-footer" style={{ background: "#364F6B" }}>
      {/* CTA band */}
      <div className="border-b border-white/10">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-14 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
          <div>
            <h2 className="text-white text-3xl lg:text-4xl font-bold leading-tight">{FOOTER.cta.heading}</h2>
            <p className="text-white/75 mt-4 text-[15px] leading-relaxed max-w-xl">{FOOTER.cta.sub}</p>
          </div>
          <div className="lg:justify-self-end">
            <div className="flex flex-wrap gap-5 mb-5">
              {FOOTER.cta.ticks.map((t) => (
                <span key={t} className="inline-flex items-center gap-2 text-white/90 text-[14px]">
                  <span className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: "#2FE1EC" }}>
                    <Check size={13} color="#364F6B" strokeWidth={3} />
                  </span>
                  {t}
                </span>
              ))}
            </div>
            <a href={FOOTER.cta.button.href} className="btn-aqua inline-block px-7 py-3 text-[15px]" data-testid="footer-cta-signup">
              {FOOTER.cta.button.label}
            </a>
          </div>
        </div>
      </div>

      {/* Columns */}
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-14 grid grid-cols-2 lg:grid-cols-5 gap-8">
        <a href={SITE.home} className="col-span-2 lg:col-span-1">
          <img src={SITE.logo} alt="GDPR Local" className="h-9 w-auto brightness-0 invert" />
        </a>
        {FOOTER.columns.map((col) => (
          <div key={col.title}>
            <h4 className="text-white font-bold text-[15px] mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-white/70 hover:text-aqua transition-colors text-[13.5px] leading-snug">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Company block */}
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 pb-10">
        <div className="text-white/60 text-[13px] leading-relaxed">
          <div>{FOOTER.company.line1}</div>
          <div>{FOOTER.company.line2}</div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-white/60 text-[13px]">{FOOTER.bottom.copyright}</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {FOOTER.bottom.legal.map((l) => (
              <a key={l.label} href={l.href} className="text-white/60 hover:text-aqua transition-colors text-[13px]">{l.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
